import contentful from 'clients/contentful'
import Author from 'components/blog/author'
import Layout from 'components/layout'
import { UrbanistProvider } from 'providers/font-providers/urbanist-provider'

export default function ExpertPage({ topNav, footer, author, posts }) {
  return (
    <UrbanistProvider>
      <Layout title={`${author?.name || 'Author'} | Kickoff`}>
        <Author topNav={topNav} author={author} posts={posts} footer={footer} />
      </Layout>
    </UrbanistProvider>
  )
}

export async function getStaticProps({ params }) {
  const [topNavRes, footerRes, authorRes, postRes] = await Promise.all([
    contentful.getEntries({
      content_type: 'blogTopNavigationBar',
      include: 3,
    }),
    contentful.getEntries({
      content_type: 'blogFooter',
      include: 3,
    }),
    contentful.getEntries({
      content_type: 'author',
      'fields.slug': params.slug,
    }),
    contentful.getEntries({
      content_type: 'newBlogPost',
      'fields.author.sys.contentType.sys.id': 'author',
      'fields.author.fields.slug[in]': params.slug,
      'fields.slug[nin]': 'editorial-guidelines',
    }),
  ])

  return {
    props: {
      topNav: topNavRes.items[0],
      footer: footerRes.items[0],
      author: authorRes.items[0],
      posts: postRes.items,
    },
    revalidate: 10,
  }
}

export async function getStaticPaths() {
  const res = await contentful.getEntries({
    content_type: 'author',
    'fields.type': 'expert',
    order: '-sys.createdAt',
  })

  const paths = res.items.map(({ fields }) => `/blog/expert/${fields.slug}`)

  return {
    paths,
    fallback: 'blocking',
  }
}
